function moveSwitcher() {
  var switcher = document.querySelector('.colour-switcher');
  var formButtons = document.querySelector('.product-form-buttons');
  if (switcher && formButtons) {
    formButtons.insertBefore(switcher, formButtons.firstChild);
    return true;
  }
  return false;
}

if (!moveSwitcher()) {
  var observer = new MutationObserver(function() {
    if (moveSwitcher()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
